// extracted by mini-css-extract-plugin
module.exports = {"theme":"forbes1_theme__M5htx"};